import { BaseApi } from '@/modules/core/base.api';
import { Breadcrumb } from './breadcrumb';
import { User } from '@/modules/user/user';
import { Device } from '@/modules/device/device';
import * as API from '@shared/common/api';

class BreadcrumbApi extends BaseApi {
    public apiPath = 'breadcrumb';

    public async findAll(options: any = {}): Promise<any> {
        const response = await this.api.get(this.baseUrlFor(), {
            params: {
                ...options,
            },
        });

        response.data.items = response.data.items.map((breadcrumb: any) => {
            const breadcrumbInstance = new Breadcrumb(breadcrumb);
            if (breadcrumbInstance.device) {
                breadcrumbInstance.device = new Device(breadcrumbInstance.device);
            }

            if (breadcrumbInstance.createdBy) {
                breadcrumbInstance.createdBy = new User(breadcrumbInstance.createdBy);
            }

            if (breadcrumbInstance.updatedBy) {
                breadcrumbInstance.updatedBy = new User(breadcrumbInstance.updatedBy);
            }

            if (breadcrumbInstance.stoppedBy) {
                breadcrumbInstance.stoppedBy = new User(breadcrumbInstance.stoppedBy);
            }

            return breadcrumbInstance;
        });
        return response.data;
    }

    public async create(breadcrumb: any): Promise<API.CreateBreadcrumb> {
        const response = await this.api.post<API.CreateBreadcrumb>(this.baseUrlFor(), breadcrumb);
        return response.data;
    }

    public async getCount(options: any): Promise<API.GetBreadcrumbCount> {
        const response = await this.api.get<API.GetBreadcrumbCount>(this.baseUrlFor('count'), {
            params: {
                ...options,
            },
        });
        return response.data;
    }

    public getExportUrl(options?: any): string {
        return this.api.getUri({ url: this.baseUrlFor('export'), params: options ? { sort: options.sort, ...options.filters } : undefined });
    }
}

export const breadcrumbApi = new BreadcrumbApi();
